import * as ACTIONS from '../actions/constants';


const initialState = {
  canWeCancel: false,
  cancelled: null
};


function order(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CANCELABLE:
        return { ...state, canWeCancel: action.payload };
    case ACTIONS.CANCEL_ORDER:
        return { ...state, cancelled: action.payload };
    default:
      return state;
  }
}

export default order;



// WEBPACK FOOTER //
// ./src/reducers/order.js